@if (apps.length > 0) {
  <div>
    @if (permissions.applicationPermissions._edit) {
      <div class="row">
        <div class="col-md-12">
          <button mat-raised-button
            class="subscribe-sequence"
            (click)="addTaxCreditApplication()">
            Add Application
          </button>
        </div>
      </div>
    }
    @for (app of apps; track app) {
      <div>
        <div class="row align-top gutters">
          <div class="col-md-12">
            <div class="app-header">
              <mat-icon>corporate_fare</mat-icon>
              <span class="org-name"><a href="{{app.url}}">{{app.org}}</a></span>
              <span class="fund-round">{{app.round}}</span>
              @if (app.roundName) {
                <span class="fund-round">: {{app.roundName}}</span>
              }
            </div>
            <div class="app-info">
              @if (app.dueDate) {
                <span>
                  <b>Due Date: </b>{{app.dueDate}}
                </span>
              }
              @if (app.awardDate) {
                <span>
                  <b>Award Date: </b>{{app.awardDate}}
                </span>
              }
            </div>
          </div>
        </div>
        <div class="row align-top gutters bottom-space">
          <div class="col-md-12">
            <deal-tax-credit-applications-table [apps]="app.table" [permissions]="permissions" (projectStatusChange)="passProjectStatus($event)" (deleteFinancingTerm)="passFinancingTerm($event)"></deal-tax-credit-applications-table>
          </div>
        </div>
      </div>
    }
  </div>
}

@if (apps.length <= 0) {
  <div class="row align-top gutters">
    @if (permissions.applicationPermissions._edit) {
      <div class="row">
        <div class="col-md-12">
          <button mat-raised-button
            class="subscribe-sequence"
            (click)="addTaxCreditApplication()">
            Add Application
          </button>
        </div>
      </div>
    }
    <div class="col-md-12">
      <em>There are no Tax Credit Applications for this deal.</em>
    </div>
  </div>
}
